
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useAuthActions} from "./AuthAction";
import {useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState} from "recoil";
import {teacherIdState} from "../../recoil/teacher/teacherIdState";
import {authState} from "../../recoil/auth/authState";
import {getCookie, setCookie} from "../../cookie/Cookie";
import { topMenuTypeState} from "../../recoil/menuState/topMenuState";

const LoginCallback = () => {
    const navigate = useNavigate();
    const { authLoginAsync } = useAuthActions();
    const [teacherId, setTeacherId] = useRecoilState(teacherIdState);
    const auth = useRecoilValue(authState);
    const resetTopMenu = useResetRecoilState(topMenuTypeState);


    useEffect(() => {
        // OAuth 콜백 URL에서 토큰 추출 (초기 실행 시 한 번만 수행)
        const params = new URLSearchParams(window.location.search);
        const idToken = params.get("idToken");
    //    console.log(idToken);
        if (idToken) {
            authLoginAsync({ idToken })
                .then(() => {
                    resetTopMenu();
                    setTeacherId(auth.teacher.teacherId);
                    navigate("/page/home"); // 로그인 성공 후 리디렉션
                    // window.history.replaceState(null, "", "/"); // 주소창에서 경로를 숨김
                })
                .catch((error) => {
                    console.error("로그인 실패:", error);
                });
        }
    }, []); // 빈 배열을 사용해 한 번만 실행되도록 설정


    return (
        <div>
            <h2>로그인 중 입니다...</h2>
        </div>
    );
}

export default LoginCallback;